export default __webpack_public_path__ + "static/media/Eosense-logo-w-tagline-300ppi.68f5c02c.png";